import React, { useState } from 'react';
import { StyledSearchBar, StyledSearchInput, StyledSearchIcon, StyledCloseIcon } from './SearchBar.styles.mjs';

const SearchBar = ({ placeholder = 'Search...', onSearch, onChange, disabled = false, className, value, ariaLabel = 'Search input', onClose, showCloseIcon = false }) => {
    const [internalValue, setInternalValue] = useState('');
    const currentValue = value !== undefined ? value : internalValue;
    const handleChange = event => {
        const newValue = event.target.value;
        if (value === undefined) {
            setInternalValue(newValue);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    };
    const handleKeyDown = event => {
        if (event.key === 'Enter' && currentValue.trim()) {
            event.preventDefault();
            onSearch(currentValue.trim());
        }
    };
    const handleSearch = (event) => {
        event.stopPropagation();
        if (currentValue.trim()) {
            onSearch(currentValue.trim());
        }
    };
    const handleClose = (event) => {
        event.stopPropagation();
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    return (React.createElement(StyledSearchBar, { className: className },
        React.createElement(StyledSearchInput, { type: "text", value: currentValue, onChange: handleChange, onKeyDown: handleKeyDown, placeholder: placeholder, disabled: disabled, "aria-label": ariaLabel }),
        React.createElement(StyledSearchIcon, { onClick: handleSearch, disabled: disabled, "aria-label": "Search" },
            React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))),
        showCloseIcon && onClose && (React.createElement(StyledCloseIcon, { onClick: handleClose, "aria-label": "Close search" },
            React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M18 6L6 18M6 6L18 18", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))))));
};

export { SearchBar as default };
//# sourceMappingURL=SearchBar.mjs.map
